import Pusher from "pusher-js";
let pusher = null;

const commonPusher = {
  init() {
    pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
      cluster: "ap1",
    });
  },

  getPusher() {
    return pusher;
  },
};

export default commonPusher;
